
import { useState, useEffect, useContext, createContext } from "react";


import { FeatureTypeSelector, ProgramSelector, SubjectSelector, SubjectTypeSelector } from "@Beasted1010/pivotal-wisdom";

import { fetchLandingPageData } from "../utilities/server-fetch";

import mockPAS from "../data/OLD/LandingPages/mock-pas.json";
import mockHeroSection from "../data/OLD/LandingPages/mock-above-the-fold-hero-section.json";
import mockFeatureFocused from "../data/OLD/LandingPages/mock-feature-focused.json";
import mockLeadCaptureForm from "../data/OLD/LandingPages/mock-lead-capture-form.json";
import mockLongFormContent from "../data/OLD/LandingPages/mock-long-form-content.json";
import mockTestimonialDriven from "../data/OLD/LandingPages/mock-testimonial-driven.json";



export {
  LandingPageContextProvider,
  useLandingPage, useLandingPageUpdate
};


const LandingPageContext = createContext<any>( null ); // TODO: Properly fill out

const LandingPageUpdateContext = createContext<any>( null ); // TODO: Properly fill out


function useLandingPage() {
  return useContext( LandingPageContext );
}

function useLandingPageUpdate() {
  return useContext( LandingPageUpdateContext );
}


interface ILandingPageIdentifier { // Add to Shared Library for Server use as well..
  subjectType?: SubjectTypeSelector;
  subjectSelector?: SubjectSelector;
  programSelector?: ProgramSelector;
  featureSelector?: FeatureTypeSelector;

  toolName?: string;
}

interface LandingPageContextProps {
  children?: JSX.Element | JSX.Element[];

  category: string; // TODO: USE LandingPageCategory ENUM FROM SERVER... (add to Shared Library)
  identifier: ILandingPageIdentifier;
}

//function LandingPageContextProvider( {subjectType, subjectSelector, programSelector, children}: LandingPageContextProps ) {
function LandingPageContextProvider( {category, identifier, children}: LandingPageContextProps ) {
  // Provider handles...

  // ... Creating State
  const [ landingPageData, setLandingPageData ] = useState<any>( ); // TODO: TYPE - Get ILandingPage from Server (add to Shared Repo??)


  useEffect( () => {

    const abortController: AbortController = new AbortController();
    async function updateData() {
      const data: any = await fetchLandingPageData({ 
        category: category,
        identifier: identifier,

        signal: abortController.signal
      });

      setLandingPageData( data );
    }

    updateData();

    return () => {
      abortController.abort(); // TODO: Don't think this is doing anything now since getAllProgramFeaturesFromServer() is handling abort only if Exception... maybe pass abortController to method (will that work, pass by Ref?) ??
    }

    /*
    let landingPageTestDataType: string;
    //landingPageTestDataType = "PAS";
    //landingPageTestDataType = "HeroSection";
    //landingPageTestDataType = "FeatureFocused";
    //landingPageTestDataType = "LeadCaptureForm";
    //landingPageTestDataType = "LongFormContent";
    landingPageTestDataType = "TestimonialDriven"; // TODO: Broken in test?
    switch( landingPageTestDataType ) {
      case "PAS": setLandingPageData( mockPAS ); break;
      case "HeroSection": setLandingPageData( mockHeroSection ); break;
      case "FeatureFocused": setLandingPageData( mockFeatureFocused ); break;

      // TODO: LeadCaptureForm & LongFormContent not be working / rendering as expected - LOOK MORE INTO WHEN NEED
      case "LeadCaptureForm": setLandingPageData( mockLeadCaptureForm ); break;
      case "LongFormContent": setLandingPageData( mockLongFormContent ); break;

      case "TestimonialDriven": setLandingPageData( mockTestimonialDriven ); break;
    }
    */
  }, []);


  // ... Updating State



  // ... Persisting State down into Children
  return (
    <LandingPageContext.Provider value={ {landingPageData} } >
      <LandingPageUpdateContext.Provider value={ {} } >
        {children}
      </LandingPageUpdateContext.Provider>
    </LandingPageContext.Provider>
  )
}















/* */
